function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "icon-external");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "icon-external",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M100.835556,178.978 L120.888889,199 L192,128 L120.888889,57 L100.835556,77.022 L137.528889,113.8 L0,113.8 L0,142.2 L137.528889,142.2 L100.835556,178.978 Z M227.555556,0 L28.4444444,0 C12.6577778,0 0,12.8 0,28.4444444 L0,85.3333333 L28.4444444,85.3333333 L28.4444444,28.4444444 L227.555556,28.4444444 L227.555556,227.555556 L28.4444444,227.555556 L28.4444444,170.666667 L0,170.666667 L0,227.555556 C0,243.2 12.6577778,256 28.4444444,256 L227.555556,256 C243.2,256 256,243.2 256,227.555556 L256,28.4444444 C256,12.8 243.2,0 227.555556,0 Z",
  id: "Shape-Copy",
  fill: "#00893f",
  fillRule: "nonzero"
}));

var SvgIconExternal = function SvgIconExternal(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconExternal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-external.11cab170.svg";
export { ForwardRef as ReactComponent };